"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FeesPrototype = {
  get: function get() {
    return this.$http.get(this.prefix);
  },
  create: function create(props) {
    return this.$http.post("" + this.prefix, props);
  },
  update: function update(id, props) {
    return this.$http.put(this.prefix + "/" + id, props);
  }
};

exports.default = function (feis_id, $http) {
  return Object.assign({
    $http: $http,
    prefix: IFEIS_API_URI + "/api/feiseanna/" + feis_id + "/fees"
  }, FeesPrototype);
};


//////////////////
// WEBPACK FOOTER
// ./feiseanna/fees/index.js
// module id = 482
// module chunks = 0